import {useControllerProps} from './Widget/ControllerContext';
import React, {useEffect} from 'react';
import {useSlotPlaceholder} from '@wix/widget-plugins-ooi';
import {SlotId} from '../../domain/utils/slotId';
import {usePaymentsApi} from '../../common/components/WithPaymentsApi/WithPaymentsApi';
import {PaymentMethod} from '@wix/cashier-payments-widget';

export const CheckoutSlot = /* istanbul ignore next: test slot */ ({
  slotId,
  className,
}: {
  slotId: SlotId;
  className: string;
}) => {
  const {
    slotsStore: {setSlotsParams, setStepId, setPaymentId, setCheckoutUpdatedDate},
    stepsManagerStore: {activeStep},
    checkoutStore,
  } = useControllerProps();

  const {activePaymentId} = usePaymentsApi();
  const checkoutUpdatedDate = checkoutStore.cart.updatedDate;

  useEffect(
    () => {
      setSlotsParams(slotId);
    },
    /* eslint-disable react-hooks/exhaustive-deps*/ []
  );

  useEffect(() => {
    setStepId(slotId, activeStep.stepId);
  }, [activeStep]);

  useEffect(() => {
    setPaymentId(slotId, activePaymentId as PaymentMethod);
  }, [activePaymentId]);

  useEffect(() => {
    setCheckoutUpdatedDate(slotId, checkoutUpdatedDate);
  }, [checkoutUpdatedDate]);

  const [Placeholder, isEmpty] = useSlotPlaceholder(slotId);

  return (
    <div className={`${isEmpty ? '' : className}`}>
      <Placeholder />
    </div>
  );
};
